import React from 'react';
import { Input, Form } from 'formik-antd';
import { Formik, FormikProps, prepareDataForValidation } from 'formik';
import * as Yup from 'yup';

import FormItem from 'components/formik/FormItem';
import Checkbox from 'components/formik/Checkbox';
import FormikEffect from 'components/formik/FormikEffect';

import styles from './AssignmentTemplate.module.less';

export interface TemplateFormValues {
  templateName: string;
  isNeedCreateTemplate?: boolean;
}

export const isTemplateFormValidForDraft = (
  formik: FormikProps<TemplateFormValues>,
  isTemplateEditMode: boolean,
) => {
  const dataForValidation = prepareDataForValidation(formik?.values);

  return getTemplateInitialValidationSchema(isTemplateEditMode).isValidSync(
    dataForValidation,
  );
};

const getTemplateInitialValidationSchema = (isTemplateEditMode: boolean) => {
  const schema: any = {
    templateName: Yup.string().when('isNeedCreateTemplate', {
      is: (isNeedCreateTemplate: boolean) =>
        isNeedCreateTemplate || isTemplateEditMode,
      then: Yup.string()
        .trim()
        .required('Field is required')
        .max(120, `Template name should be 120 characters maximum`),
    }),
  };

  if (!isTemplateEditMode) {
    schema.isNeedCreateTemplate = Yup.boolean();
  }

  return Yup.object(schema);
};

type Props = {
  formRef: any;
  setIsTemplateErrors: (hasError: boolean) => void;
  isTemplateEditMode: boolean;
  initialValues?: TemplateFormValues;
};

export default function AssignmentTemplate(props: Props) {
  const { formRef, setIsTemplateErrors, isTemplateEditMode, initialValues } =
    props;

  const onChange = () =>
    setIsTemplateErrors(
      !isTemplateFormValidForDraft(formRef.current, isTemplateEditMode),
    );

  const getInitialValues = (): TemplateFormValues => {
    if (isTemplateEditMode) {
      return {
        templateName: initialValues?.templateName || '',
      };
    }
    return {
      templateName: '',
      isNeedCreateTemplate: false,
    };
  };

  return (
    <Formik
      enableReinitialize
      innerRef={formRef}
      initialValues={getInitialValues()}
      validationSchema={getTemplateInitialValidationSchema(isTemplateEditMode)}
      onSubmit={() => {}}
    >
      {(formik) => (
        <>
          <FormikEffect onChange={onChange} />
          <Form layout="vertical" className={styles.form}>
            {!isTemplateEditMode && (
              <div>
                <FormItem
                  data-id="assignmentMakeTemplate"
                  name="isNeedCreateTemplate"
                >
                  <span className={styles.label}>Save as Template?</span>
                  <Checkbox name="isNeedCreateTemplate">Yes</Checkbox>
                </FormItem>
              </div>
            )}

            {(formik.values.isNeedCreateTemplate || isTemplateEditMode) && (
              <div className={styles.growBox}>
                <FormItem data-id="assignmentTemplateName" name="templateName">
                  <Input
                    name="templateName"
                    placeholder="Enter template name"
                    autoComplete="off"
                  />
                </FormItem>
              </div>
            )}
          </Form>
        </>
      )}
    </Formik>
  );
}
